var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 19.3 19.3",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "city") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "city",
    transform: "translate(0.650000, 0.650000)",
    fillRule: "nonzero",
    stroke: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18,9 C18,13.968 13.968,18 9,18 C4.032,18 0,13.968 0,9 C0,4.0275 4.032,0 9,0 C13.968,0 18,4.0275 18,9",
    id: "Fill-12",
    strokeWidth: 1.3,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,9 C14,11.76 11.76,14 9,14 C6.24,14 4,11.76 4,9 C4,6.2375 6.24,4 9,4 C11.76,4 14,6.2375 14,9",
    id: "Fill-12",
    strokeWidth: 0.7,
    fill: "#2B2B2B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCity);
export default __webpack_public_path__ + "static/media/city.8499886ea0bec5a1cc73f164b953a5e2.svg";
export { ForwardRef as ReactComponent };